import { render, staticRenderFns } from "./GroupMemberPopover.vue?vue&type=template&id=5cdca24b&scoped=true&"
import script from "./GroupMemberPopover.vue?vue&type=script&lang=ts&"
export * from "./GroupMemberPopover.vue?vue&type=script&lang=ts&"
import style0 from "./GroupMemberPopover.vue?vue&type=style&index=0&id=5cdca24b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdca24b",
  null
  
)

export default component.exports